// smsService.ts
import axios, { AxiosError } from "axios";
import { ApiResponse } from "../../types/BaseModals/ApiResponse";
import { API_URL } from "../../constants/API_URL";
import { SMSConfigModal, SMSResponseModal } from "../../types/modals";
import { SingleTextSMSRequestModal } from "../../types/RequestModals/SingleTextSMSRequestModal";
import { SMSError } from "../../types/ErrorModals/SMSError";

// SMS hata kodlarını açıklamalara çeviren fonksiyon
export const getSMSErrorMessage = (messageId: string): string => {
  switch (messageId) {
    case "01":
      return "Hatalı Kullanıcı Adı, Şifre ya da Bayi Kodu";
    case "02":
      return "Yetersiz Kredi / Ödenmemiş Fatura Borcu";
    case "03":
      return "Tanımsız Action Parametresi";
    case "05":
      return "XML Düğümü Eksik ya da Hatalı";
    case "06":
      return "Tanımsız Originator";
    case "07":
      return "Mesaj Kodu (ID) yok";
    case "09":
      return "Tarih alanları hatalı";
    case "10":
      return "SMS Gönderilemedi";
    default:
      return `Bilinmeyen hata kodu: ${messageId}`;
  }
};

// Hata kodu olup olmadığını kontrol eden fonksiyon
export const isSMSErrorCode = (messageId: string): boolean => {
  return ["01", "02", "03", "05", "06", "07", "09", "10"].includes(messageId);
};

export const sendSingleTextSMS = async (
  request: SingleTextSMSRequestModal
): Promise<SMSResponseModal> => {
  try {
    const response = await axios.post<ApiResponse<SMSResponseModal>>(
      `${API_URL}/api/SMS/sendSingleTextSMS`,
      request
    );

    if (!response.data.success) {
      throw new Error(response.data.message);
    }

    // Hata kodu kontrolü
    const result = response.data.data!;
    if (isSMSErrorCode(result.messageId)) {
      const error = getSMSErrorMessage(result.messageId);
      throw {
        message: error,
      } as SMSError;
    }

    return result;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;

      // API'den dönen veri içinde messageId kontrolü
      if (
        responseData?.data?.messageId &&
        isSMSErrorCode(responseData.data.messageId)
      ) {
        throw {
          message: getSMSErrorMessage(responseData.data.messageId),
          correlationId: responseData?.correlationId,
          additionalData: responseData?.additionalData,
        } as SMSError;
      }

      // Diğer API hataları
      if (axiosError.response?.status === 400) {
        throw {
          message: responseData?.message || "Geçersiz istek",
          errors: responseData?.errors,
          correlationId: responseData?.correlationId,
        } as SMSError;
      }

      throw {
        message: responseData?.message || "Bir hata oluştu",
        correlationId: responseData?.correlationId,
        additionalData: responseData?.additionalData,
      } as SMSError;
    }


    throw error as SMSError;
  }
};

export const getSMSConfig = async (
  kurumKodu: string
): Promise<SMSConfigModal> => {
  try {
    const response = await axios.get<ApiResponse<SMSConfigModal>>(
      `${API_URL}/api/SMS/getSMSConfig/${kurumKodu}`
    );
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    return response.data.data!;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;
      throw {
        message: responseData?.message || "SMS ayarları alınamadı",
        correlationId: responseData?.correlationId,
        additionalData: responseData?.additionalData,
      } as SMSError;
    }
    throw {
      message: "Beklenmeyen bir hata oluştu",
    } as SMSError;
  }
};
